import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer style={{ padding: "24px 0", borderTop: "1px solid #e5e7eb", marginTop: "40px" }}>
      <Container className="d-flex flex-column flex-md-row justify-content-between align-items-center">
        <div style={{ marginBottom: "12px" }}>
          <strong>JSONHelper.io</strong> <span style={{ color: "#6b7280" }}>© {new Date().getFullYear()}</span>
        </div>

        <div className="d-flex gap-3">
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/contact">Contact</Link>
        </div>
      </Container>
    </footer>
  );
}